// The dashboard filter controller
//
// Used by both airport dashboard and admin assessment map.
// Supports two filtering modes:
// 1. Airport dashboard: Uses filter() method with pre-rendered URLs in links
// 2. Admin assessment map: Uses filterBySelect() with Stimulus values to construct URLs for dropdowns

import { navigator } from '@hotwired/turbo'
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Optional Stimulus values - only used by admin assessment map for dropdown filtering
  // Airport dashboard doesn't define these; it reads from URL query string instead
  static values = {
    dateFrom: String,
    days: String,
    basePath: String
  }

  connect() {
    // console.log('Dashboard filter controller connected - now trigger filter changed');
    // Controller will re-load after user changes filter, so we can hook into this event
    // to trigger map to get the shapes reloaded
    // This global event will be picked up by dashboard-map controller
    console.log('Dashboard filter controller connected - now trigger filter changed');
      const event = new CustomEvent("filter-changed")
      window.dispatchEvent(event)
  }

  async getResults(url) {
    // console.log('Dashboard filter getResults with url:', url)
    history.pushState({}, null, url.toString())
    navigator.history.push(new URL(url))
    fetch(url, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    }).then(r => r.text())
        .then(html => Turbo.renderStreamMessage(html))
  }

  // Used by airport dashboard: Gets full URL from link href, makes Turbo Stream request
  filter(event) {
    const url = event.target.href
    // console.log('dashboard filter (turbo stream) with link:', url)
    if (url == null) { return }
    event.preventDefault()
    this.getResults(url)
  }

  get dashboardMapController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("dashboard-map-id"), "dashboard-map")
  }

  // Used by admin assessment map: Constructs URL from dropdown values + Stimulus values, does full page reload
  filterBySelect(event) {
    const assessmentSiteId = document.querySelector('#assessment_site_id').value;
    const assessmentType = document.querySelector('#assessment_type').value;

    const url = this.basePathValue +
                '?assessment_site_id=' + assessmentSiteId +
                '&assessment_type=' + assessmentType +
                '&date_from=' + this.dateFromValue +
                '&days=' + this.daysValue;

    window.location.href = url;
  }

}
